// Currency utility functions
export const currencySymbols = {
  'US': '$',
  'IN': '₹',
  'GB': '£',
  'EU': '€',
  'JP': '¥'
};

export const countryCurrencyMap = {
  US: 'USD',
  IN: 'INR',
  GB: 'GBP',
  EU: 'EUR',
  JP: 'JPY'
};

// Format price with proper currency symbol
export const formatPrice = (price, countryCode) => {
  if (!price || !currencySymbols[countryCode]) {
    return 'N/A';
  }
  
  const numericPrice = parseFloat(price);
  if (isNaN(numericPrice)) {
    return 'N/A';
  }
  
  return `${currencySymbols[countryCode]}${numericPrice.toFixed(2)}`;
};

// Get user's country with fallback to India
export const getUserCountry = () => {
  const stored = sessionStorage.getItem('userCountry');
  return stored || 'IN'; // Default to India
};

// Set user's country
export const setUserCountry = (countryCode) => {
  if (currencySymbols[countryCode]) {
    sessionStorage.setItem('userCountry', countryCode);
    return true;
  }
  return false;
};

// Detect country using IP geolocation
export const detectUserCountry = async () => {
  try {
    // Check session storage first
    const stored = sessionStorage.getItem('userCountry');
    if (stored) {
      return stored;
    }
    
    // Default to India for users accessing from India
    let detectedCountry = 'IN';
    
    try {
      // Try IP geolocation API
      const response = await fetch('https://ipapi.co/json/', { 
        timeout: 5000,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const countryCode = data.country_code;
        
        // Map country codes to our supported countries
        if (countryCode === 'US') detectedCountry = 'US';
        else if (countryCode === 'IN') detectedCountry = 'IN';
        else if (countryCode === 'GB') detectedCountry = 'GB';
        else if (['DE', 'FR', 'IT', 'ES', 'NL'].includes(countryCode)) detectedCountry = 'EU';
        else if (countryCode === 'JP') detectedCountry = 'JP';
        
        console.log(`Detected country: ${countryCode}, mapped to: ${detectedCountry}`);
      }
    } catch (apiError) {
      console.log('Geolocation API failed, using default India');
    }
    
    // Save detected country
    sessionStorage.setItem('userCountry', detectedCountry);
    return detectedCountry;
  } catch (error) {
    console.error('Error detecting country:', error);
    // Default to India
    sessionStorage.setItem('userCountry', 'IN');
    return 'IN';
  }
};